import { usePayment } from '@/core/api/payments';
import type {
	Form,
	InwardDetails,
	InwardMessage,
	NestedProfile,
	OutwardDetails,
	OutwardInstruction,
} from '@/core/types/payments';

export function useNestedPaymentForms(paymentObjectName: string) {
	const { data, isPending } = usePayment(paymentObjectName);

	const profile = data?.nestedRelation.find((r) => r.object.archetype === 'profile')?.object as
		| NestedProfile
		| undefined;

	const nestedForms =
		data?.nestedRelation.filter((r) => r.object.archetype === 'form').map((r) => r.object) ?? [];

	const inwardForm = nestedForms.find((f) => f.kind === 'inward_message') as
		| Form<InwardMessage>
		| undefined;

	const outwardForm = nestedForms.find((f) => f.kind === 'outward_instruction') as
		| Form<OutwardInstruction>
		| undefined;

	const inwardDetails = nestedForms.find((f) => f.kind === 'inward_details') as
		| Form<InwardDetails>
		| undefined;

	const outwardDetails = nestedForms.find((f) => f.kind === 'outward_details') as
		| Form<OutwardDetails>
		| undefined;

	return {
		profile,
		inwardForm,
		outwardForm,
		inwardDetails,
		outwardDetails,
		isPending,
	};
}
